import SidebarLayout from "../../../../layouts/SidebarLayout";
import sidebar from "../../utils/sidebar";
import PageSubHeader from "../../../../components/Layouts/PageSubHeader";
import { useTranslation } from "react-i18next";
import { Col, NavItem, Row, NavLink, Nav, TabContent } from "reactstrap";
import { useEffect, useState } from "react";
import LeadSourcesTab from "./Tabs/LeadSources";
import CallPurposesTab from "./Tabs/CallPurposes";
import CallResultsTab from "./Tabs/CallRsults";
import { get } from "../../../../utils/helpers/api";

function SettingsPage() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('lead-sources');
  const [loading, setLoading] = useState(false);
  const [leadSources, setLeadSources] = useState(null);
  const [callPurposes, setCallPurposes] = useState(null);
  const [callResults, setCallResults] = useState(null);

  const getSettingsData = async () => {
    setLoading(true);
    const data = await get('/crm/settings');
    if(data?.success) {
      setLeadSources(data?.lead_sources);
      setCallPurposes(data?.call_purposes);
      setCallResults(data?.call_results);
    }
    setLoading(false);
  }

  useEffect(() => {
    getSettingsData();
  }, []);

  const TABS = [
    { id: 'lead-sources', label: t('crm.settings.lead_sources.title') },
    { id: 'call-purposes', label: t('crm.settings.call_purposes.title') },
    { id: 'call-results', label: t('crm.settings.call_results.title') }
  ];

  return(
    <SidebarLayout sidebar={sidebar}>
      <div className="page-with-subheader">
        <PageSubHeader title={t('crm.settings.title')} />
        <div className="subheader-page-content scrollable">
          <Row className="align-items-start">
            <Col lg="2">
              <Nav pills vertical className="flex-column pref-nav">
                {TABS.map(tab => (
                  <NavItem key={tab.id}>
                    <NavLink
                      active={activeTab === tab.id}
                      onClick={() => setActiveTab(tab.id)}
                      className="cursor-pointer"
                    >
                      {tab.label}
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>
            </Col>
            <Col lg="10">
              <TabContent activeTab={activeTab} className="pref-tab-content">
                <LeadSourcesTab 
                  leadSources={leadSources}
                  refreshSettings={getSettingsData}
                />

                <CallPurposesTab 
                  callPurposes={callPurposes}
                  refreshSettings={getSettingsData}
                />

                <CallResultsTab 
                  callResults={callResults}
                  refreshSettings={getSettingsData}
                />
              </TabContent>
            </Col>
          </Row>
        </div>
      </div>
    </SidebarLayout>
  );
}

export default SettingsPage;
